import { IOption } from '../input.types';

export const MONATE_OPTIONS: IOption<number>[] = [
  { value: 1, name: 'Jänner' },
  { value: 2, name: 'Februar' },
  { value: 3, name: 'März' },
  { value: 4, name: 'April' },
  { value: 5, name: 'Mai' },
  { value: 6, name: 'Juni' },
  { value: 7, name: 'Juli' },
  { value: 8, name: 'August' },
  { value: 9, name: 'September' },
  { value: 10, name: 'Oktober' },
  { value: 11, name: 'November' },
  { value: 12, name: 'Dezember' }
];

export const MONATE_MIT_EMPTY_OPTIONS: IOption<number | undefined>[] = [
  { value: undefined, name: '-' },
  ...MONATE_OPTIONS
];
